import { mapActions, mapState } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

import dayjs from 'dayjs';
import { GET_ACTIVE_MEMBERS } from '@/store/member/constants';
import { PRICE_PER_MEMBER } from '@/utils/constants';

export default {
  name: 'Upgraded',
  computed: {
    ...mapState('member', {
      loading: ({ isGettingMembers }) => isGettingMembers,
      members: ({ members }) => members,
    }),
    memberLength() {
      return this.members?.length;
    },
    monthlyPrice() {
      return this.memberLength * PRICE_PER_MEMBER;
    },
    nextPaymentDate() {
      return dayjs().add(1, 'month').endOf('month').format('YYYY/MM/DD');
    },
  },
  async mounted() {
    try {
      await this.getActiveMembers();
    } catch (ex) {
      const errorMessage = ex.message ? `(${ex.message})` : '';

      Toast.open({
        message: `帳戶已成功升級，但無法取得預估費用${errorMessage}`,
        type: 'is-warning',
      });
    }
  },
  methods: {
    ...mapActions('member', {
      getActiveMembers: GET_ACTIVE_MEMBERS,
    }),
  },
};
